import { dropStatusOrdemFabricacao, dropTipoOfab } from 'utils/drops';

const getOrdensFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusOrdemFabricacao,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'dtemissao.i',
    column: 'documento',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtemissao.f',
    column: 'documento',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'przent.i',
    column: 'documento',
    label: 'Prazo de Entrega Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'przent.f',
    column: 'documento',
    label: 'Prazo de Entrega Final',
    type: 'date',
    defaultValue: null,
  },
  { name: 'origem', column: 'documento', label: 'Origem', defaultValue: '' },
  {
    name: 'tipo',
    label: 'Tipo',
    column: 'documento',
    type: 'select',
    options: dropTipoOfab,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'cliente',
    label: 'Cliente',
    column: 'documento',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'producao_calculo_id',
    label: 'Lote de Cálculo',
    column: 'documento',
    type: 'number',
    defaultValue: '',
  },
  { name: 'produto', label: 'Produto', defaultValue: '' },
  { name: 'referencia', label: 'Referência', defaultValue: '' },
  {
    name: 'linha',
    label: 'Linha',
    column: 'produto',
    type: 'select',
    options: drops?.LinhaProduto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'grupo',
    label: 'Grupo',
    column: 'produto',
    type: 'select',
    options: drops?.GrupoProduto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'aplicacao',
    label: 'Aplicação',
    column: 'produto',
    type: 'select',
    options: drops?.Aplicacao,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'produtobase',
    label: 'Produto Base',
    column: 'produto',
    type: 'virtual-select',
    options: drops?.Produto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'processo',
    label: 'Processo Atual',
    defaultValue: '',
  },
  {
    name: 'ccusto',
    label: 'Centro de Custo',
    column: 'processo',
    type: 'select',
    options: drops?.Ccusto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'quantidade_produzir',
    label: 'Quantidade a Produzir',
    type: 'currency',
    defaultValue: '',
  },
  {
    name: 'quantidade_produzida',
    label: 'Quantidade Produzida',
    column: 'quantidade_produzir',
    type: 'currency',
    defaultValue: '',
  },
];

export default getOrdensFilterFields;
